import {
  ActivitiesActivitiesClient,
  ActivityStatus,
  TournamentActivitiesList,
  TournamentActivity,
  TournamentActivityUnviewedCount,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig, { platformType } from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const activitiesClient = new ActivitiesActivitiesClient(
  apiConfig,
  undefined,
  axiosInstance
);

interface GetResultActivitiesParams {
  page?: number;
  limit?: number;
  startDate?: string;

  activityStatus?: ActivityStatus;
  endDate?: string;
}

const handleGetResultActivities = async (
  params?: GetResultActivitiesParams
): Promise<TournamentActivitiesList> => {
  const { page, limit, startDate, activityStatus, endDate } = params || {};

  return (
    await activitiesClient.getUserTournamentActivities(
      platformType,
      page,
      limit,
      activityStatus,
      startDate,
      endDate
    )
  ).data;
};

const handleGetUnviewedResultCount =
  async (): Promise<TournamentActivityUnviewedCount> => {
    return (
      await activitiesClient.getTournamentActivitiesUnviewedCount(
        platformType
      )
    ).data;
  };

const handleMarkResultAsViewed = async (
  referenceId: string
): Promise<TournamentActivity> => {
  return (
    await activitiesClient.markActivityAsViewed(platformType, referenceId)
  ).data;
};

export {
  handleGetResultActivities,
  handleGetUnviewedResultCount,
  handleMarkResultAsViewed,
  GetResultActivitiesParams,
};
